<template>
	<div class="min-height-inherit">
		<div id="login-form" class="row justify-content-center align-items-center min-height-inherit">
			<div class="col-12">
				<div id="login-box" class="text-center">
					<h1 class="fs-2-5 pt-3 lh-1-1 mb-3 text-white">Entra nell’area docente</h1>
					<p class="semibold mb-2">
						Inserisci le tue credenziali.
					</p>

					<form @submit.prevent="logIn" class="text-start pb-3">
						<div class="row justify-content-center">
							<div class="col-12 mb-2">
								<label for="user" class="mb-1">Email</label>
								<input type="text" name="user" id="user" class="form-control rounded-pill" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.user">
							</div>
							<div class="col-12 mb-2">
								<label for="password" class="mb-1">Password</label>
								<input :type="pwdInputType" name="password" id="password" class="form-control pwd-show rounded-pill" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.password">
								<i class="fa fa-eye" :class="{'fa-eye' : !showPwd, 'fa-eye-slash' : showPwd}" aria-hidden="true" @click.prevent="showHidePwd"></i>
							</div>

							<div class="col-12 my-4 text-center">
								<button type="submit" class="btn btn-green btn-lg rounded-pill px-5"><span>Entra</span></button>
							</div>

							<div class="col-12 error-msg error-msg-login p-2 rounded-3 bg-blue-ultra-light fs-0-9" v-html="form.errorMsg" v-if="form.errorMsg != ''"></div>

							<div class="col-12 mb-0 text-center">
								<p class="fs-0-8 mb-0">Hai dimenticato la password? <a :href="urls.changePwdUrl" class="bold underline white fs-0-8">Clicca qui</a></p>
							</div>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'LogInFormCmponent',
	props: ['urls'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			form: {
				user: '',
				password: '',
				errorMsg: ''
			},
			showPwd: false,
			pwdInputType: 'password'
		}
	},

	methods: {
		logIn() {
			let url = this.ajaxObj.ajax_url
			this.form.errorMsg = ''

			let data = new FormData();
			data.append('action', 'nl_907u_log_in')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('user', this.form.user)
			data.append('password', this.form.password)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					if(response.data.err) {
						for( let k in response.data.msg) {
							if (response.data.msg[k][0] == 'Indirizzo email sconosciuto. Ricontrolla o prova ad usare il tuo nome utente.') {
								this.form.errorMsg = "Indirizzo email sconosciuto. Controlla e inserisci nuovamente l’email con cui ti sei registrato."
							} else if(response.data.msg[k][0] == '<strong>Errore:</strong> il nome utente <strong>nardo_bz@yahoo.</strong> non è registrato su questo sito. Se non sei sicuro del tuo nome utente, prova invece il tuo indirizzo email.') {
								this.form.errorMsg = "Indirizzo email sconosciuto. Controlla e inserisci nuovamente l’email con cui ti sei registrato."
							} else {
								this.form.errorMsg = response.data.msg[k][0]
							}
						}
					} else {
						// window.dataLayer.push({'event': 'user-signup-promo'})
						window.location.href = response.data.redirect
					}
				}, (error) => {
					console.log(error);
				});
		},

		showHidePwd() {
			if(this.pwdInputType == 'password') {
				this.pwdInputType = 'text'
				this.showPwd = true
			} else {
				this.pwdInputType = 'password'
				this.showPwd = false
			}
		}
	}
}
</script>

<style scoped>
	.pwd-show {
		display: inline-block;
	}
	.fa.fa-eye {
		margin-left: -30px;
		cursor: pointer;
		color: #79a52b;
	}
</style>
